import { render } from "./TermsAndConditions.vue?vue&type=template&id=4220fee2&scoped=true"
import script from "./TermsAndConditions.vue?vue&type=script&lang=ts"
export * from "./TermsAndConditions.vue?vue&type=script&lang=ts"

import "./TermsAndConditions.vue?vue&type=style&index=0&id=4220fee2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-4220fee2"

export default script